<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { ref } from "vue";
const currentDate = ref(new Date());
export default {
  data() {
    return {
      startdate: currentDate,
      events: [],
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        headerToolbar: {
          left: "title, prev,today next",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
        },
        events: [
          {
            title: "12:30am Laptop serv...",
            start: currentDate,
            textColor: "#242B3A",
            className: "fc-event-title",
          },
          {
            title: "10:00am House Clean..",
            start: "2024-09-04",
            end: "2024-09-04",
            textColor: "#242B3A",
          },
          {
            title: "11:00am Washing ...",
            start: "2024-09-05",
            end: "2024-09-05",
            textColor: "#242B3A",
          },
          {
            title: "02:00pm Toughened...",
            start: "2024-09-10",
            end: "2024-09-10",
            textColor: "#242B3A",
          },
          {
            title: "05:00pm Interior ...",
            start: "2024-09-16",
            end: "2024-09-16",
            textColor: "#242B3A",
          },
          {
            title: "01:00pm Building....",
            start: "2024-09-18",
            end: "2024-09-18",
            textColor: "#242B3A",
          },
        ],

        initialView: "dayGridMonth",
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
      },
    };
  },
  props: {
    msg: String,
  },
  components: {
    FullCalendar,
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4"
          >
            <h4>Booking</h4>
            <div class="d-flex align-items-center flex-wrap row-gap-3">
              <p class="text-dark me-2 mb-0">Sort</p>
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Newly Added
                </a>
                <div class="dropdown-menu">
                  <a href="javascript:void(0);" class="dropdown-item active"
                    >Newly Added</a
                  >
                  <a href="javascript:void(0);" class="dropdown-item">Oldest</a>
                </div>
              </div>
              <router-link
                to="/provider/provider-booking-calendar"
                class="tags active d-flex justify-content-center align-items-center border rounded me-2"
                ><i class="ti ti-calendar-month"></i
              ></router-link>
              <router-link
                to="/provider/provider-booking"
                class="tags d-flex justify-content-center align-items-center border rounded me-2"
                ><i class="ti ti-list"></i
              ></router-link>
              <a
                href="javascript:void(0);"
                class="btn btn-dark d-flex align-items-center"
                data-bs-toggle="modal"
                data-bs-target="#add_booking"
                ><i class="ti ti-circle-plus me-2"></i>Add Bookings</a
              >
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div id="calendar-book">
              <FullCalendar :options="calendarOptions" :events="events"></FullCalendar>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-between align-items-center flex-wrap row-gap-3"
        >
          <div class="value d-flex align-items-center">
            <span>Show</span>
            <select>
              <option>7</option>
            </select>
            <span>entries</span>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <span class="me-2 text-gray-9">1 - 07 of 10</span>
            <nav aria-label="Page navigation">
              <ul class="paginations d-flex justify-content-center align-items-center">
                <li class="page-item me-2">
                  <a
                    class="page-link-1 active d-flex justify-content-center align-items-center"
                    href="javascript:void(0);"
                    >1</a
                  >
                </li>
                <li class="page-item me-2">
                  <a
                    class="page-link-1 d-flex justify-content-center align-items-center"
                    href="javascript:void(0);"
                    >2</a
                  >
                </li>
                <li class="page-item">
                  <a
                    class="page-link-1 d-flex justify-content-center align-items-center"
                    href="javascript:void(0);"
                    >3</a
                  >
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <provider-booking-modal></provider-booking-modal>
  </div>
</template>
